import type { HTMLAttributes } from 'react';

export interface DividerProps extends Omit<HTMLAttributes<HTMLDivElement>, 'role'> {
  orientation?: 'horizontal' | 'vertical';
}

export const Divider = ({ orientation = 'horizontal', className = '', ...props }: DividerProps) => (
  <div
    {...props}
    className={`app-divider ${className}`.trim()}
    role="separator"
    aria-orientation={orientation}
    data-orientation={orientation}
  />
);
